"use client";

import LandingPage from "pages/main-layout/landing/page";

/**
 * Muggle Test product entry point for the shared marketing landing page (`pages/main-layout/landing/page`).
 * Terms & Privacy access is provided by the shared landing footer link.
 */
export function MainPageV2() {
  return <LandingPage />;
}
